<template>
  <ModalConfirmation
    :showModal="showOauthConfigReloadModal"
    title="Update Failed"
  >
    <template v-slot:body>
      <ParagraphBody>
        The configuration update failed and your changes were not saved.
        <br>
        <strong>Do you want to keep editing or discard the changes?</strong>
      </ParagraphBody>
    </template>
    <template v-slot:footer>
      <ButtonGroup
        :fullWidth="false"
      >
        <ButtonSecondary
          text="Discard changes"
          type="error"
          @click="revertChanges"
        />
        <Button
          text="Keep editing"
          @click="$emit('close')"
        />
      </ButtonGroup>
    </template>
  </ModalConfirmation>
</template>

<script>
import {
  Button,
  ButtonGroup,
  ButtonSecondary,
  ModalConfirmation,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions } from 'vuex';

const { application } = ItemTypeConsts;
const ApplicationModel = StoreModelMap[application];

export default {
  name: 'IdmOauthConfigReloadModal',

  components: {
    Button,
    ButtonGroup,
    ButtonSecondary,
    ModalConfirmation,
    ParagraphBody,
  },

  props: {
    showOauthConfigReloadModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions(ApplicationModel, ['resetCustomApiConfig']),

    revertChanges() {
      this.resetCustomApiConfig();
      this.$emit('close');
    },
  },
};
</script>
